import React, { useCallback, useState } from 'react';
import { UploadCloud, FileSpreadsheet, X } from 'lucide-react';
interface DropZoneProps {
  onFileSelect: (file: File) => void;
}
export function DropZone({
  onFileSelect
}: DropZoneProps) {
  const [isDragging, setIsDragging] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const handleDragOver = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(true);
  }, []);
  const handleDragLeave = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);
  }, []);
  const handleDrop = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);
    setError(null);
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      validateAndPassFile(files[0]);
    }
  }, []);
  const handleFileInput = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      validateAndPassFile(e.target.files[0]);
    }
  }, []);
  const validateAndPassFile = (file: File) => {
    if (file.type === 'text/csv' || file.name.endsWith('.csv')) {
      onFileSelect(file);
    } else {
      setError('Please upload a valid CSV file.');
    }
  };
  return <div className="w-full max-w-2xl mx-auto" data-id="element-17">
      <div onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} className={`
          relative border-2 border-dashed rounded-xl p-12 text-center transition-all duration-200 ease-in-out
          ${isDragging ? 'border-blue-500 bg-blue-50 scale-[1.02]' : 'border-slate-300 bg-slate-50 hover:border-slate-400 hover:bg-slate-100'}
        `} data-id="element-18">
        <input type="file" accept=".csv" onChange={handleFileInput} className="absolute inset-0 w-full h-full opacity-0 cursor-pointer" data-id="element-19" />

        <div className="flex flex-col items-center justify-center space-y-4 pointer-events-none" data-id="element-20">
          <div className={`p-4 rounded-full ${isDragging ? 'bg-blue-100 text-blue-600' : 'bg-white text-slate-400 shadow-sm'}`} data-id="element-21">
            {isDragging ? <UploadCloud className="w-10 h-10" data-id="element-22" /> : <FileSpreadsheet className="w-10 h-10" data-id="element-23" />}
          </div>

          <div className="space-y-1" data-id="element-24">
            <h3 className="text-lg font-semibold text-slate-900" data-id="element-25">
              {isDragging ? 'Drop file to upload' : 'Drag & drop your CSV here'}
            </h3>
            <p className="text-sm text-slate-500" data-id="element-26">
              or click to browse from your computer
            </p>
          </div>

          <div className="text-xs text-slate-400 pt-2" data-id="element-27">
            Supported format: .csv
          </div>
        </div>
      </div>

      {error && <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg flex items-center justify-between text-red-700 text-sm animate-in fade-in slide-in-from-top-2" data-id="element-28">
          <span data-id="element-29">{error}</span>
          <button onClick={() => setError(null)} className="hover:bg-red-100 p-1 rounded" data-id="element-30">
            <X className="w-4 h-4" data-id="element-31" />
          </button>
        </div>}
    </div>;
}